import { Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ComponentPageHeader from '../../Common/PageHeader/ComponentPageHeader';
import DataTable from '../../Common/DataTable';
import { LevelListingInterface, LevelTableColumns } from './utils/types';
import { getAllLevels } from '../../redux/masters/masterSlice';
import { setLoader } from '../../redux/loaderSlice';
import { RootState } from '../../redux/rootState';
import AddLevelModal from './components/AddZipCodeModalComponent/AddLevelModal';
import DeleteLevelConfirmationModal from './components/DeleteLevelConfirmationModal/ComponentDeleteTubeChartModal';

function Levels() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [showUserModal, setShowUserModal] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const {
    isLoading, allLevelsList, isLevelCreated, isLevelDeleted,
  } = useSelector((state: RootState) => state.masterDataReducer);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const handleData = () => {
    const payload = {
      pageSize: rowsPerPage,
      searchItem: searchQuery,
      pageNumber: page,
    };
    dispatch(getAllLevels(payload));
  };

  useEffect(() => {
    if (isLevelCreated) {
      handleData();
    }
  }, [isLevelCreated]);
  useEffect(() => {
    if (isLevelDeleted) {
      handleData();
    }
  }, [isLevelDeleted]);

  useEffect(() => {
    handleData();
  }, []);

  const tableData = useMemo(() => {
    if (allLevelsList?.Data?.length > 0) {
      // eslint-disable-next-line arrow-body-style
      const transformedData = allLevelsList?.Data?.map((item) => {
        return {
          action: 'edit&delete',
          id: String(item?.Id),
          description: item?.Description,
        };
      });
      return transformedData;
    }
    return [];
  }, [allLevelsList]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <ComponentPageHeader subHeading="LEVELS" />
          {/* <ComponentPageHeader subHeading="ZIP CODES" downloadExcel={() => {}} /> */}
        </Grid>
        <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
          {/* <DataTable<ZipCodeListingInterface> */}
          <DataTable<LevelListingInterface>
            data={tableData}
            columns={LevelTableColumns}
            totalRecords={allLevelsList?.TotalRecords}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            handleData={handleData}
            buttonText="Add new Level"
            handleButtonClick={() => {
              setShowUserModal('Add');
            }}
            handleEdit={(e) => {
              setSelectedId(e);
              setShowUserModal('Edit');
            }}
            handleDelete={(e) => {
              setSelectedId(e);
              setShowDeleteModal(true);
            }}
          />
        </Grid>
      </Grid>
      {showUserModal
        && (
          <AddLevelModal
            show={showUserModal}
            selectedId={selectedId}
            setOpenFrom={() => setShowUserModal('')}
          />
        )}
      {showDeleteModal
        && (
          <DeleteLevelConfirmationModal
            show={showDeleteModal}
            selectedId={selectedId}
            setOpenFrom={() => setShowDeleteModal(false)}
          />
        )}
    </>
  );
}

export default Levels;
